export default __webpack_public_path__ + "static/media/loading.7d2e28ce.svg";